import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";

class ProductsSortModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        return (
            <Modal {...this.props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Информация о сортах</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table">
                        <thead>
                        <tr>
                            <th/>
                            <th style={{width: '174px'}}>Высший сорт</th>
                            <th>1-ый сорт</th>
                            <th>2-ой сорт</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Использовался</td>
                            <td>2-3 раза</td>
                            <td>до 5 раз</td>
                            <td>до 7 раз</td>
                        </tr>
                        <tr>
                            <td>Цвет</td>
                            <td>как у нового</td>
                            <td>незначительные потемнения до светло-серого цвета</td>
                            <td>потемнение до серого цвета</td>
                        </tr>
                        <tr>
                            <td>Состояние</td>
                            <td>нет сломанных деталей</td>
                            <td>нет сломанных деталей</td>
                            <td>нет сломанных деталей</td>
                        </tr>
                        <tr>
                            <td>Сколы на досках</td>
                            <td>нет</td>
                            <td>до 2 см.</td>
                            <td>до 2 см.</td>
                        </tr>
                        <tr>
                            <td>Загрязнения</td>
                            <td>нет</td>
                            <td>до 20% площади. Нетехнического и неорганического происхождения</td>
                            <td>до 60% площади. Нетехнического и неорганического происхождения</td>
                        </tr>
                        </tbody>
                    </table>
                    <p>
                        Определяющими критериями разделения поддонов между Высшим, 1 и 2 сортами являются (в порядке важности):
                    </p>
                    <ul>
                        <li>Цвет поддона</li>
                        <li>Общее состояние поддона (качество сборки, прочность конструкции)</li>
                        <li>Количество трещин и сколов</li>
                        <li>Степень загрязнения поддона</li>
                    </ul>
                    <div className="alert alert-warning">
                        <ol>
                            <li className="m-b-1">Пограничные по цвету и состоянию (сколы, трещины, степень износа, аспергилл) сорта поддонов принимаются как более низкие сорта (определяющим является цвет по внешнему контуру поддона, т.е вид сбоку по периметру);</li>
                            <li className="m-b-1">Поддоны с превышением допусков по аспергиллу, загрязнениям, окрашенности, обзолу, коре, горбылю, принимаются в сорт ниже.</li>
                            <li>Поддоны с превышением допусков по сколам и трещинам принимаются в ремонтные поддоны соответствующих сортов. Исключение – Евро ВС и типовой ВС.</li>
                        </ol>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-default"
                            onClick={this.props.onHide}>
                        Закрыть
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ProductsSortModal;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Products/ProductsSortModal.js